/**
 * @generated SignedSource<<8572acdccf2a51db6cd2bf8fb8e5903c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type SearchLinkedResultCategory = "child" | "mentionedBy" | "mentions" | "similar" | "%future added value";
export type SearchResultType = "ask" | "attachment" | "blogpost" | "board" | "comment" | "component" | "dashboard" | "database" | "document" | "embed" | "filter" | "focus_area" | "focus_area_status_update" | "folder" | "goal" | "goal_update" | "issue" | "learning" | "message" | "object" | "page" | "plan" | "position" | "presentation" | "project" | "project_update" | "question" | "repository" | "schema" | "slide" | "space" | "spreadsheet" | "tag" | "type" | "unrecognised" | "video" | "whiteboard" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type searchGraphComment_AtlassianSearchPage$data = {
  readonly __typename: "SearchResultGraphDocument";
  readonly entity: {
    readonly container?: {
      readonly displayName?: string | null | undefined;
      readonly url?: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly excerpt: string | null | undefined;
  readonly id: string;
  readonly lastModifiedDate: string | null | undefined;
  readonly linkedResults: ReadonlyArray<{
    readonly category: SearchLinkedResultCategory;
    readonly connectorType: string | null | undefined;
    readonly description: string;
    readonly id: string;
    readonly integrationId: string | null | undefined;
    readonly lastModifiedDate: string | null | undefined;
    readonly providerId: string | null | undefined;
    readonly subtype: string | null | undefined;
    readonly title: string;
    readonly type: SearchResultType;
    readonly url: string;
  }> | null | undefined;
  readonly title: string;
  readonly url: string;
  readonly " $fragmentType": "searchGraphComment_AtlassianSearchPage";
};
export type searchGraphComment_AtlassianSearchPage$key = {
  readonly " $data"?: searchGraphComment_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchGraphComment_AtlassianSearchPage">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = {
  "kind": "ScalarField",
  "name": "title"
},
v2 = {
  "kind": "ScalarField",
  "name": "url"
},
v3 = {
  "kind": "ScalarField",
  "name": "lastModifiedDate"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "searchGraphComment_AtlassianSearchPage",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    (v0/*: any*/),
    (v1/*: any*/),
    (v2/*: any*/),
    {
      "kind": "ScalarField",
      "name": "excerpt"
    },
    (v3/*: any*/),
    {
      "kind": "LinkedField",
      "name": "entity",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "LinkedField",
              "name": "container",
              "plural": false,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "displayName"
                    },
                    (v2/*: any*/)
                  ],
                  "type": "ExternalSpace"
                }
              ]
            }
          ],
          "type": "ExternalComment"
        }
      ]
    },
    {
      "concreteType": "SearchLinkedResult",
      "kind": "LinkedField",
      "name": "linkedResults",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        (v2/*: any*/),
        {
          "kind": "ScalarField",
          "name": "type"
        },
        {
          "kind": "ScalarField",
          "name": "description"
        },
        (v3/*: any*/),
        {
          "kind": "ScalarField",
          "name": "category"
        },
        {
          "kind": "ScalarField",
          "name": "subtype"
        },
        {
          "kind": "ScalarField",
          "name": "integrationId"
        },
        {
          "kind": "ScalarField",
          "name": "providerId"
        },
        {
          "kind": "ScalarField",
          "name": "connectorType"
        }
      ]
    }
  ],
  "type": "SearchResultGraphDocument"
};
})();

(node as any).hash = "b17f6d38cfefaa62af51c3cdcd08a442";

export default node;
